import { defineStore } from 'pinia';

export const useSessionStore = defineStore('session', {
    state: () => ({
        timestamp: 0,
        session_id: '',
        instagramDataLoaded: false,
        experienceScore: 0,
        expFlagsScore: 0,
        expGoogleMapsReview: 0,
        experienceLoaded: false,
        experienceError: '',
        storytellingScore: 0,
        stlgFrequencyScore: 0,
        stlgShareScore: 0,
        stlgCoherenceScore: 0,
        stlgReasoning: '',
        storytellingLoaded: false,
        storytellingError: '',
        communityScore: 0,
        commTaggedTimeDifferenceScore: 0,
        commEngageRateBenchmark: 0,
        commLikeMedianScore: 0,
        communityLoaded: false,
        communityError: '',
        company_name: '',
        company_id: '',
        website: '',
        flag_contacts_section: false,
        flag_instagram_on_homepage: false,
        flag_facebook_on_homepage: false,
        flag_newsletter: false,
        flag_multilingual: false,
        flag_physical_store: false,
        flag_login_option: false,
        flag_online_shop: false,
        instagram: '',
        facebook: '',
        linkedin: '',
        website_contents: [],
    }),

    actions: {
        init(session_id, timestamp, company_name, company_id, website) {
            this.session_id = session_id;
            this.timestamp = timestamp;
            this.company_name = company_name;
            this.company_id = company_id;
            this.website = website;
        },

        setExperienceFlags(metrics) {
            this.flag_contacts_section = metrics.flag_contacts_section;
            this.flag_instagram_on_homepage = metrics.flag_instagram_on_homepage;
            this.flag_facebook_on_homepage = metrics.flag_facebook_on_homepage;
            this.flag_newsletter = metrics.flag_newsletter;
            this.flag_multilingual = metrics.flag_multilingual;
            this.flag_physical_store = metrics.flag_physical_store;
            this.flag_login_option = metrics.flag_login_option;
            this.flag_online_shop = metrics.flag_online_shop;
        },

        setSocial(social) {
            this.instagram = social.instagram;
            this.facebook = social.facebook;
            this.linkedin = social.linkedin;
        },

        setScore(scoreType, score_dict) {
            if (scoreType === 'storytelling') {
                this.storytellingScore = score_dict.storytelling_score;
                this.stlgFrequencyScore = score_dict.stlg_frequency_score;
                this.stlgShareScore = score_dict.stlg_share_score;
                this.stlgCoherenceScore = score_dict.stlg_coherence_score;
                this.stlgReasoning = score_dict.stlg_reasoning;
                this.storytellingLoaded = true;
            } else if (scoreType === 'community') {
                this.communityScore = score_dict.community_score;
                this.commTaggedTimeDifferenceScore = score_dict.comm_tagged_time_diff_score;
                this.commEngageRateBenchmark = score_dict.comm_engage_rate_benchmark;
                this.commLikeMedianScore = score_dict.comm_like_median_score;
                this.communityLoaded = true;
            } else if (scoreType === 'experience') {
                this.experienceScore = score_dict.experience_score;
                this.expFlagsScore = score_dict.exp_flags_score;
                this.expGoogleMapsReview = score_dict.exp_google_maps_review;
                this.experienceLoaded = true;
            } else {
                console.error('Invalid scoreType');
            }
        },
        reset() {
            this.communityScore = 0;
            this.storytellingLoaded = false;
            this.experienceScore = 0;
            this.communityLoaded = false;
            this.storytellingScore = 0;
            this.experienceLoaded = false;
            this.stlgReasoning = "";
        }
    },

    getters: {
        getMetrics() {
            return {
                flag_contacts_section: this.flag_contacts_section,
                flag_newsletter: this.flag_newsletter,
                flag_multilingual: this.flag_multilingual,
                flag_physical_store: this.flag_physical_store,
                flag_login_option: this.flag_login_option,
                flag_online_shop: this.flag_online_shop,

            };
        },

        getMetricsAndWebsiteElements() {
            return {
                ...this.getMetrics,
                website_contents: this.website_contents
            };
        },
        getSocial() {
            return {
                instagram: this.instagram,
                facebook: this.facebook,
                linkedin: this.linkedin
            };
        },
    }
});